import {
  ALL_LAYOUT_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  Metadata,
  pick,
} from '../../../../utils/spds/metadata';
import Super from '../../core/base.gjs';
import VariableLayout from '../../layout/variable.gjs';
import styles from './content-container.module.scss';

const METADATA = Metadata.define({
  description: 'Collapsible content area for Accordion component',
  extends: [
    pick(COMPONENT_STATE_ARGS, [
      { name: 'animated', private: true },
      { name: 'open', private: true },
    ]),
    pick(CONTAINER_ARGS, ['grid', 'reverse', { name: 'column', default: true }]),
    ALL_LAYOUT_ARGS,
  ],
  name: 'Accordion Content Container',
});

export default class SpdsContainerAccordionContentContainer extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-container-accordion-content-container';
  classesToMapToArgs = ['animated', 'open'];
  styles = styles;

  get grid() {
    return this.argOrDefault('grid');
  }

  get hidden() {
    return `${!this.args.open}`;
  }

  get innerId() {
    return this.composeSubcomponentId('inner');
  }

  <template>
    <VariableLayout
      @alignContent={{@alignContent}}
      @alignItems={{@alignItems}}
      @alignSelf={{@alignSelf}}
      @area={{@area}}
      @areas={{@areas}}
      @autoFlow={{@autoFlow}}
      @column={{@column}}
      @columns={{@columns}}
      @flex={{@flex}}
      @flexWrap={{@flexWrap}}
      @gap={{@gap}}
      @grid={{this.grid}}
      @gridArea={{@gridArea}}
      @gridAutoColumns={{@gridAutoColumns}}
      @gridAutoFlow={{@gridAutoFlow}}
      @gridAutoRows={{@gridAutoRows}}
      @gridColumn={{@gridColumn}}
      @gridRow={{@gridRow}}
      @gridTemplateAreas={{@gridTemplateAreas}}
      @gridTemplateColumns={{@gridTemplateColumns}}
      @gridTemplateRows={{@gridTemplateRows}}
      @id={{this.innerId}}
      @justifyContent={{@justifyContent}}
      @justifyItems={{@justifyItems}}
      @justifySelf={{@justifySelf}}
      @order={{@order}}
      @reverse={{@reverse}}
      @row={{@row}}
      @rows={{@rows}}
      class={{this.classes}}
      data-test-spds-container-accordion-content-container
      {{this.setupComponent}}
      {{this.validateArguments}}
      aria-hidden={{this.hidden}}
      aria-labelledby={{@triggerId}}
      ...attributes
    >
      {{yield}}
    </VariableLayout>
  </template>
}

export const ACCORDION_CONTENT_CONTAINER_METADATA = SpdsContainerAccordionContentContainer.metadata;
